export const reloadAppWithLocale = (localeCode: string): void => {
    if (import.meta.client) {
        reloadNuxtApp({
            path: getCurrentUrlWithParams(localeCode),
        });
    }
};
